<template>
    <div class="rbt-main-content">
        <div class="rbt-daynamic-page-content">
            <!-- Dashboard Center Content -->
            <div class="rbt-dashboard-content">
                <template v-if="idConversa == 0">
                    <!-- nova pergunta -->
                    <div class="content-page" id="printMe">
                        <div class="chat-box-list pt--30">
                            <template v-if="!(utilizacoes && utilizacoes.permiteRealizarPerguntas) && flVerificouUtilizacoes">
                                <!-- nao pode realizar pergunta -->
                                <div class="chat-box ai-speech bg-flashlight box-anime">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20">
                                                    Desculpe, parece que você atingiu seu limite de Perguntas do contrato.
                                                    Entre em contato com um dos nossos consultores.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="etapa == 0 || statusPergunta == 'Cancelada'">
                                <template v-if="flRealizaPergunta">
                                    <div class="chat-box ai-speech bg-flashlight box-anime">
                                        <div class="inner top-flashlight leftside light-xl">
                                            <div class="chat-section">
                                                <div class="author">
                                                    <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                                </div>
                                                <div class="chat-content">
                                                    <h6 class="title">
                                                        SollAI
                                                    </h6>
                                                    <p class="mb--20">Como posso ajudá-lo hoje?</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                                        <div class="inner">
                                            <div class="chat-section">
                                                <div class="author">
                                                    <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                                </div>
                                                <div class="chat-content">
                                                    <h6 class="title">Você</h6>
                                                    <div class="form-group">
                                                        <textarea id="pergunta" placeholder="Digite sua pergunta" maxlength="5000" v-model="formPergunta.dsPergunta"></textarea>
                                                    </div>
                                                    <div class="reaction-section mt-2">
                                                        <div class="btn-grp">
                                                            <div class="left-side-btn dropup"></div>
                                                            <div class="right-side-btn">
                                                                <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(0)" v-if="!disabled">
                                                                    <span class="ms-0">Próximo</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </template>
                                <template v-else-if="flVerificouRealizar">
                                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                                        <div class="inner">
                                            <div class="chat-section">
                                                <div class="author">
                                                    <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                                </div>
                                                <div class="chat-content">
                                                    {{msgNaoRealizaPergunta}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="chat-box chat-box-you author-speech bg-flashlight">
                                    <div class="inner">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">Você</h6>
                                                <p class="text-justify">
                                                    {{formPergunta.dsPergunta}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="etapa > 0">
                                <div class="chat-box ai-speech bg-flashlight box-anime" ref="etapa1">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20">
                                                    Escolha a legislação: (Baseado em qual lei deseja a
                                                    reposta)
                                                </p>
                                                <div v-for="(item,index) in lstLeis" v-bind:key="index">
                                                    <input type="radio" :id="'option'+ index" name="idLegislacao" :value="item.value" v-model="formPergunta.idLegislacao" :disabled="disabled" />
                                                    <label :for="'option'+index">
                                                        {{index + 1}} - {{item.titulo}} - {{item.descricao}}
                                                    </label>
                                                </div>
                                                <div class="reaction-section mt-2">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup"></div>
                                                        <div class="right-side-btn">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(1)" v-if="!disabled">
                                                                <span class="ms-0">Próximo</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="etapa > 1">
                                <div class="chat-box ai-speech bg-flashlight box-anime" ref="etapa2">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20">Escolha o formato da resposta:</p>
                                                <div v-for="(item,index) in lstTiposPerguntas" v-bind:key="index">
                                                    <input type="radio" :id="'huey'+ index" name="tpPergunta" :value="item.value" v-model="formPergunta.tpPergunta" :disabled="disabled" />
                                                    <label :for="'huey'+index">
                                                        {{item.titulo}} {{item.descricao}}
                                                    </label>
                                                </div>
                                                <div class="reaction-section mt-2" v-if="utilizacoes && utilizacoes.permiteRealizarPerguntas">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup"></div>
                                                        <div class="right-side-btn">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(2)" v-if="!disabled">
                                                                <span class="ms-0">Próximo</span>
                                                            </button>
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(3)" v-if="user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br' || user.usuario.dsLogin == 'jefferson.lima'
                                                || user.usuario.dsLogin == 'gleyson.siqueira'">
                                                                <span class="ms-0">Próximo v2</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="etapa > 2">
                                <div class="chat-box ai-speech bg-flashlight box-anime">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                    <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                        {{mensagemProcessando}}
                                                    </p>
                                                    <p class="txt-p txt-grey-3 txt-size-14 txt-w-5 mb-2">
                                                        Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                    </p>
                                                    <div class="progress px-0">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                    </div>
                                                </template>
                                                <template v-if="statusPergunta == 'Cancelada'">
                                                    <span class="txt-erro txt-size-40">
                                                        <i class="fas fa-exclamation-triangle txt-erro"></i>
                                                    </span>
                                                    <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                        Erro ao processar a pergunta
                                                    </p>
                                                    <p class="txt-p txt-blue-1 txt-size-16 txt-w-5 mb-2">
                                                        {{msgErro}}
                                                    </p>
                                                    <button class="btn-default bg-solid-primary" @click="enviarPergunta" v-if="flReprocessar">
                                                        Reprocessar
                                                    </button>
                                                </template>
                                                <template v-if="statusPergunta == 'Finalizada'">
                                                    <template vif="pergunta">
                                                        <p class="mb--20" style="white-space: pre-line;" :id="'resposta_'+pergunta.idConversa" v-html="pergunta.dsResposta">
                                                        </p>
                                                    </template>
                                                </template>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <!-- carrega pergunta -->
                    <div class="content-page" id="printMe">
                        <div class="chat-box-list pt--30">
                            <div class="chat-box chat-box-you author-speech bg-flashlight" v-if="pergunta">
                                <div class="inner">
                                    <div class="chat-section">
                                        <div class="author" v-if="!flWord">
                                            <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                        </div>
                                        <div class="chat-content" id="conteudoPergunta">
                                            <h6 class="title">Você</h6>
                                            <p class="text-justify">
                                                {{pergunta.dsPergunta}}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="chat-box ai-speech bg-flashlight box-anime">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="w-100">
                                       <ReactionSection class="d-flex" v-if="!flImprimir" :top="true" :idConversa="idConversa" :imprimir="imprimir" :word="word" :proximo="proximo" :disabled="disabled"></ReactionSection>
                                    </div>
                                    <div class="chat-section">
                                        <div class="author" v-if="!flWord">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content" id="conteudoResposta">
                                            <div class="row mt-2">
                                                <div class="col-12 col-md-8" v-if="pergunta" >
                                                    <h6 class="title">
                                                        SollAI
                                                    </h6>
                                                    <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                        <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                            {{mensagemProcessando}}
                                                        </p>
                                                        <p class="txt-p txt-grey-3 txt-size-14 txt-w-5 mb-2">
                                                            Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                        </p>
                                                        <div class="progress px-0">
                                                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                        </div>
                                                    </template>
                                                    <template v-if="statusPergunta == 'Cancelada'">
                                                        <span class="txt-erro txt-size-40">
                                                            <i class="fas fa-exclamation-triangle txt-erro"></i>
                                                        </span>
                                                        <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                            Erro ao processar a pergunta
                                                        </p>
                                                        <p class="txt-p txt-blue-1 txt-size-16 txt-w-5 mb-2">
                                                            {{msgErro}}
                                                        </p>
                                                    </template>
                                                    <template v-if="statusPergunta == 'Finalizada'">
                                                        <template v-if="pergunta">
                                                            <div class="mb--20 resposta" style="white-space: pre-line; color:#000;" :id="'resposta_'+pergunta.idConversa" v-html="pergunta.dsResposta">
                                                            </div>
                                                        </template>
                                                    </template>                                                    
                                                </div>
                                                <div class="col-12 col-md-4 referencias mt-5" v-if="pergunta">
                                                    <p class="mb--0">
                                                        <strong>Data da solicitação: </strong>{{pergunta.dtPergunta}}
                                                    </p>
                                                    <p class="mb--20">
                                                        <strong>Formato de resposta: </strong>
                                                        <template v-if="pergunta.tpPergunta == 'Resposta objetiva' || pergunta.tpPergunta == 'RO'">
                                                            Resposta Objetiva
                                                        </template>
                                                        <template v-else>
                                                            Parecer técnico
                                                        </template>
                                                    </p>
                                                    <p class="mb--20"><strong>Referências utilizadas</strong></p>
                                                    <p class="mb--20 resposta"  style="white-space: pre-line;" v-if="pergunta.dsReferencias" v-html="pergunta.dsReferencias"></p>
                                                    <p class="mb--0" v-if="legislacao">
                                                        <strong>Legislação: </strong>
                                                        <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)" v-if="!flImprimir">
                                                            {{legislacao.dsNome}}
                                                        </a>
                                                        <span v-else> {{legislacao.dsNome}}</span>
                                                    </p>
                                                    <p class="mb--0" v-if="pergunta.tpPergunta != 'Resposta objetiva' && pergunta.tpPergunta != 'RO'">
                                                        <strong>Doutrina: </strong>
                                                        <br />
                                                        <a href="javascript:void(0)" @click="openDoutrina(0)" v-if="!flImprimir">
                                                            Licitações e Contratos Administrativos na Lei 14.133/21.pdf
                                                        </a>
                                                        <span v-else>Licitações e Contratos Administrativos na Lei 14.133/21.pdf</span>
                                                        <br />
                                                        <a href="javascript:void(0)" @click="openDoutrina(1)" v-if="!flImprimir">
                                                            Governança das Contratações.pdf
                                                        </a>
                                                        <span v-else>Governança das Contratações.pdf</span>
                                                    </p>
                                                    <template v-if="lstReferencias">

                                                        <div v-if="lstReferencias.lstAcordao.length > 0 || lstReferencias.lstAcordaoStf.length > 0">
                                                            <p class="mb-0"><strong>Acórdão</strong></p>
                                                            <template v-if="lstReferencias.lstAcordao.length > 0">
                                                                <h6>TCU</h6>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstAcordao" :key="index" v-html="item.dsTitulo " @click="openReferencia('ACORD', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                            <template v-if="lstReferencias.lstAcordaoStf.length > 0">
                                                                <P>STF</P>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstAcordaoStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('ACSTF', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                        </div>

                                                        <div v-if="lstReferencias.lstBoletim.length > 0 || lstReferencias.lstBoletimStf.length > 0">
                                                            <p class="mb-0"><strong>BOLETIM</strong></p>
                                                            <template v-if="lstReferencias.lstBoletim.length > 0">
                                                                <p>TCU</p>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstBoletim" :key="index" v-html="item.dsTitulo" @click="openReferencia('BOLET', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                            <template v-if="lstReferencias.lstBoletimStf.length > 0">
                                                                <P>STF</P>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstBoletimStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('BOSTF', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                        </div>

                                                        <div v-if="lstReferencias.lstJurisprudencia.length > 0 || lstReferencias.lstJurisprudenciaStf.length > 0">
                                                            <p class="mb-0"><strong>Jurisprudência</strong></p>
                                                            <template v-if="lstReferencias.lstJurisprudencia.length > 0">
                                                                <p>TCU</p>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstJurisprudencia" :key="index" v-html="item.dsTitulo" @click="openReferencia('JURIS', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                            <template v-if="lstReferencias.lstJurisprudenciaStf.length > 0">
                                                                <P>STF</P>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstJurisprudenciaStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('JUSTF', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                        </div>

                                                        <div v-if="lstReferencias.lstSumula.length > 0 || lstReferencias.lstSumulaStf.length > 0">
                                                            <p class="mb-0"><strong>Súmula</strong></p>
                                                            <template v-if="lstReferencias.lstSumula.length > 0">
                                                                <p>TCU</p>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstSumula" :key="index" v-html="item.dsTitulo" @click="openReferencia('SUMUL', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                            <template v-if="lstReferencias.lstSumulaStf.length > 0">
                                                                <P>STF</P>
                                                                <ul>
                                                                    <li class="c-pointer" v-for="(item,index) in lstReferencias.lstSumulaStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('SUSTF', item.idConteudo)"></li>
                                                                </ul>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="chat-box ai-speech bg-flashlight box-anime" >
        <div class="inner top-flashlight leftside light-xl">
            <div class="chat-section">
                <div class="author">
                    <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                </div>
                <div class="chat-content">
                    <h6 class="title">
                        SollAI
                    </h6>
                    <p class="mb--20"><strong>Você deseja criar um artefato?</strong></p>
                    <div class="right-side-btn">
                        <div class="right-side-btn">
                            <button class="react-btn btn-default btn-small btn-border">
                                <i></i><span>Criar Artefato</span>
                            </button>
                        </div>
                        <div class="reaction-section">
                            <div class="btn-grp">
                                <div class="right-side-btn">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
                        </div>
                    </div>
                </template>

                <!--<br>
                <div class="d-flex dropdown history-box-dropdown justify-content-center" >
                    <button data-bs-toggle="dropdown"
                            aria-expanded="false" class="more-info-icon dropdown-toggle react-btn btn-default btn-small btn-border">
                        <span>Downloads</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="imprimir">
                                <i class="feather-file-text"></i>
                                Baixar PDF
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="word">
                                <i class="feather-file-text"></i>
                                Baixar World
                            </a>
                        </li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="imprimir"><i class="feather-file-text"></i>Imprimir</a></li>

                    </ul>
                </div>-->
                <!--<br>
                <div class="d-flex justify-content-center ">
                    <button class="react-btn btn-default btn-small btn-border" @click="nova" v-if="utilizacoes && utilizacoes.permiteRealizarPerguntas">
                        <span>Nova Consulta</span>
                    </button>
                </div>-->

                <HistoricoPerguntas :selecionaConversa="selecionaConversa" :reload="reloadHistorico" :idConversa="idConversa"></HistoricoPerguntas>

            </div>
            

        </div>
        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
        <ModalDoutrina :tipo="tipoDoutrina" :showModal="showModalDoutrina"></ModalDoutrina>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import HistoricoPerguntas from '@/components/HistoricoPerguntas'
    import moment from 'moment'
    import ModalDetalhes from '@/components/ModalDetalhes'
    import ModalDoutrina from '@/components/ModalDoutrina'
    import ReactionSection from '@/components/ReactionSection'
    
    export default {
        name: 'Chat',
        components: { HistoricoPerguntas, ModalDetalhes, ReactionSection, ModalDoutrina},
        props: {
            reload: Boolean,
            reloadNavegacao: Function,
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
        },
        data: function () {
            return {
                idConversa: 0,
                etapa: 0,

                lstLeis: [],
                lstTiposPerguntas: [],
                lstTiposResposta: [
                    { value: 'RO', titulo: 'Resposta Objetiva', descricao: '- Apresentarei a resposta utilizando a Lei selecionada, fornecendo uma resposta direta e precisa'},
                    { value: 'PJ', titulo: 'Parecer Técnico', descricao: '- Elaborarei a resposta com base na Lei, nas normas correlatas e nas jurisprudências pertinentes, apresentando-a no formato de parecer.' },
                ],
                utilizacoes: null,
                flVerificouUtilizacoes: false,

                formPergunta: {
                    dsPergunta: null,
                    idLegislacao: null,
                    tpPergunta: null,
                },

                pergunta: null,
                
                lstReferencias: null,
                legislacao: null,

                statusPergunta: null,

                timer: 0,
                intervalTimer: null,

                msgErro: null,
                disabled: false,
                flRealizaPergunta: false,
                msgNaoRealizaPergunta: "Aguarde a conclusão da pergunta atual antes de realizar uma nova pergunta",
                mensagemProcessando: "Processando pergunta...",
                flImprimir: false,
                flWord: false,
                flReprocessar: false,
                reloadHistorico: false,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                showModalDoutrina: false,
                flVerificouRealizar: false,

                tipoDoutrina:0,
            }
        },
        methods: {
            nova() {
                this.idConversa = 0;
                this.etapa = 0;
                this.formPergunta = { dsPergunta: null, idLegislacao: null, tpPergunta: null, };
                this.pergunta = null;
                this.statusPergunta = null;
                this.timer = 0;
                this.intervalTimer = null;
                this.msgErro = null;
                this.disabled = false;

                this.load();
            },

            selecionaConversa(idConversa) {
                this.idConversa = parseInt(idConversa);
                this.load();
            },

            load() {
                if (this.idConversa != 0) {
                    this.disabled = true;
                    this.carregaConversa();
                }

                this.verificaRealizaPergunta();
                this.carregaUtilizacoes();

                this.getLeis();
                //this.lstLeis = [
                //    { value: 1, titulo: "14.133, DE 1º DE ABRIL DE 2021", descricao: " Lei de Licitações e Contratos Administrativos." },
                //    { value: 2, titulo: "8.666, DE 21 DE JUNHO DE 1993", descricao: "REVOGADA - Regulamenta o art. 37, inciso XXI..." },
                //    { value: 3, titulo: "13.303, DE 30 DE JUNHO DE 2016", descricao: "Dispõe sobre o estatuto jurídico da empresa pública..." },
                //];
            },

            carregaConversa() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/Get/${$this.idConversa}`)
                    .then(res => {
                        $this.etapa = 3;
                        $this.pergunta = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstConversaMovimento.length > 0) {
                                status = result.lstConversaMovimento[result.lstConversaMovimento.length - 1].dsMovimento;
                                $this.statusPergunta = status;
                            }

                            $this.formPergunta = {
                                dsPergunta: result.conversa.dsPergunta,
                                idLegislacao: result.conversa.idLegislacao,
                                tpPergunta: result.conversa.tpPergunta,
                            };
                            $this.pergunta = {
                                idConversa: result.conversa.idConversa,
                                dsPergunta: result.conversa.dsPergunta,
                                dsResposta: (result.conversa.dsResposta != null?result.conversa.dsResposta.replace(/(?:\r\n|\r|\n)/g, "<br>"):null),
                                tpPergunta: result.conversa.tpPergunta,
                                dsLogin: result.conversa.dsLogin,
                                status: status,
                                solicitante: result.solicitante,
                                dtPergunta: moment(result.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                idLegislacao: result.conversa.idLegislacao,
                                dsReferencias: (result.conversa.dsReferencias != null ? result.conversa.dsReferencias.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                            };
                            $this.getConversaReferencias();

                            if (result.conversa.idLegislacao) {
                                $this.getLegislacao(result.conversa.idLegislacao);
                            }

                        } else {
                            avisoErro("Não foi possível carregar a pergunta.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        $this.loading.hide();
                    });
            },

            getConversaReferencias() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/GetConversaReferencias/${$this.idConversa}`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            let result = res.data.data;
                            $this.lstReferencias = {
                                lstAcordao: [],
                                lstAcordaoStf: [],
                                lstBoletim: [],
                                lstBoletimStf: [],
                                lstJurisprudencia: [],
                                lstJurisprudenciaStf: [],
                                lstSumula: [],
                                lstSumulaStf: [],
                            };
                            for (let i = 0; i < result.length; i++) {
                                let item = result[i];
                                switch (item.tpConteudo) {
                                    case "ACORD":
                                        $this.lstReferencias.lstAcordao.push(item);
                                        break;
                                    case "ACORDSTF":
                                        $this.lstReferencias.lstAcordaoStf.push(item);
                                        break;

                                    case "BOLET":
                                        $this.lstReferencias.lstBoletim.push(item);
                                        break;
                                    case "BOLETSTF":
                                        $this.lstReferencias.lstBoletimStf.push(item);
                                        break;

                                    case "JURIS":
                                        $this.lstReferencias.lstJurisprudencia.push(item);
                                        break;
                                    case "JURISSTF":
                                        $this.lstReferencias.lstJurisprudenciaStf.push(item);
                                        break;

                                    case "SUMUL":
                                        $this.lstReferencias.lstSumula.push(item);
                                        break;
                                    case "SUMULSTF":
                                        $this.lstReferencias.lstSumulaStf.push(item);
                                        break;
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar as referencias.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            getLegislacao(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get/${idLegislacao}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacao = result;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.formPergunta.dsPergunta != '' && this.formPergunta.dsPergunta != null && this.formPergunta.dsPergunta.length >= 3) {
                            this.etapa = 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("A pergunta deve conter pelo menos 3 caracteres", "warning");
                        }
                        break;

                    case 1:
                        if (this.formPergunta.idLegislacao != null) {
                            this.getTipoPergunta(this.formPergunta.idLegislacao);
                            this.etapa = 2;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa2;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione uma legislação", "warning");
                        }                        
                        break;

                    case 2:
                        if (this.formPergunta.tpPergunta != null) {
                            if (this.utilizacoes && this.utilizacoes.permiteRealizarPerguntas) {
                                this.etapa = 3;
                                this.enviarPergunta();
                            } else {
                                avisoToast("Desculpe, parece que você atingiu seu limite de Perguntas do contrato. Entre em contato com um dos nossos consultores.", "warning");
                            }
                        } else {
                            avisoToast("Selecione um formato de resposta", "warning");
                        }
                        break;

                    case 3:
                        if (this.formPergunta.tpPergunta != null) {
                            if (this.utilizacoes && this.utilizacoes.permiteRealizarPerguntas) {
                                this.etapa = 3;
                                this.enviarPerguntav2();
                            } else {
                                avisoToast("Desculpe, parece que você atingiu seu limite de Perguntas do contrato. Entre em contato com um dos nossos consultores.", "warning");
                            }
                        } else {
                            avisoToast("Selecione um formato de resposta", "warning");
                        }
                        break;

                    default:
                        break;
                }
            },

            enviarPergunta() {
                let $this = this;
                $this.statusPergunta = 'Processando';
                $this.disabled = true;
                $this.iniciaProcessando();

                axios.post(`${urlApi}/conversa/post`, { dsPergunta: $this.formPergunta.dsPergunta, tpPergunta: $this.formPergunta.tpPergunta, idLegislacao: $this.formPergunta.idLegislacao }, { showloading: false })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Pergunta registrada com sucesso, acompanhe a situação no campo status da listagem.");
                            $this.reloadHistorico = !$this.reloadHistorico;
                            $this.reloadNavegacao();
                            $this.selecionaConversa(res.data.msg);
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusPergunta = 'Cancelada';
                        $this.msgErro = 'Não conseguimos responder sua pergunta';
                        if (res.response.data) {
                            if (res.response.data.msg == 'Nossa ia não identificou esse assunto relacionado com licitações e contratos') {
                                var msg = res.response.data.msg;
                                $this.msgErro = msg;
                                if (res.response.data.errors) {
                                    msg = msg + '. ' + res.response.data.errors[0];
                                }
                                avisoErro(msg);
                            } else {
                                avisoErro("Não foi possível enviar a pergunta.");
                            }
                        } else {
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    });
            },

            enviarPerguntav2() {
                let $this = this;
                $this.statusPergunta = 'Processando';
                $this.disabled = true;
                $this.iniciaProcessando();

                axios.post(`${urlApi}/conversa/postv2`, { dsPergunta: $this.formPergunta.dsPergunta, tpPergunta: $this.formPergunta.tpPergunta, idLegislacao: $this.formPergunta.idLegislacao }, { showloading: false })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Pergunta registrada com sucesso, acompanhe a situação no campo status da listagem.");
                            $this.reloadHistorico = !$this.reloadHistorico;
                            $this.reloadNavegacao();
                            $this.selecionaConversa(res.data.msg);
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusPergunta = 'Cancelada';
                        $this.msgErro = 'Não conseguimos responder sua pergunta';
                        if (res.response.data) {
                            if (res.response.data.msg == 'Nossa ia não identificou esse assunto relacionado com licitações e contratos') {
                                var msg = res.response.data.msg;
                                $this.msgErro = msg;
                                if (res.response.data.errors) {
                                    msg = msg + '. ' + res.response.data.errors[0];
                                }
                                avisoErro(msg);
                            } else {
                                avisoErro("Não foi possível enviar a pergunta.");
                            }
                        } else {
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    });
            },

            iniciaProcessando: function () {
                let $this = this;
                if (this.statusPergunta == 'Processando') {
                    var flag = true;
                    $this.timer = 0;

                    if (flag) {
                        flag = false;
                        $this.intervalTimer = setInterval(function () {
                            if ($this.timer < 100) {
                                $this.timer = $this.timer + 1;
                            } else {
                                flag = true;
                                clearInterval($this.intervalTimer);
                            }
                        }, 3000);
                    }
                } else {
                    if ($this.intervalTimer && $this.intervalTimer != null) {
                        clearInterval($this.intervalTimer);
                    }
                }
            },

            getLeis() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLeis = [];
                            for (let i = 0; i < res.data.data.length; i++) {
                                var item = res.data.data[i];

                                $this.lstLeis.push({ value: item.idLegislacao, titulo: item.dsNome, descricao: item.dsLegislacao });
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            getTipoPergunta(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/TipoPergunta/Get`, { showLoading: false, params: { idLegislacao: idLegislacao } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTiposPerguntas = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                $this.lstTiposPerguntas.push({ value: item.cdTipoPergunta, titulo: item.dsNome, descricao: item.dsTipoPergunta, });
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    //var token = $this.user.accessToken;
                    //var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + $this.user.usuario.dsLogin, { accessTokenFactory: () => token }).build();

                    $this.hubConection.on("RecebeNotificacao", function (idConversa, status, dtAtualizacao) {
                        if ($this.idConversa == idConversa) {
                            $this.load();
                        } else {
                            avisoToast('Status da pergunta atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                        //if ($this.perguntas.findIndex((element) => element.idConversa == idConversa) != -1) {
                        //    $this.perguntas[$this.perguntas.findIndex((element) => element.idConversa == idConversa)].status = status;
                        //    $this.perguntas[$this.perguntas.findIndex((element) => element.idConversa == idConversa)].dtAtualizacao = moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm');
                        //}
                    });

                    $this.hubConection.on("AtualizaRealizarPergunta", function (flRealizaPergunta) {
                        $this.flRealizaPergunta = flRealizaPergunta == "Sim" || flRealizaPergunta == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatus", function (idConversa, status,) {
                        $this.mensagemProcessando = status;
                    });

                    //$this.hubConection.start().then(function () {
                    //    //console.log('Connetado!');
                    //}).catch(function (err) {
                    //    return console.error('Erro: ', err.toString());
                    //});

                    //$this.hubConection.onclose(async () => {
                    //    setTimeout(function () {
                    //        console.log('Tentando Reconectar!');
                    //        $this.hubConection.start();
                    //    }, 5000);
                    //});
                }
                catch(ex)
                {
                    //console.log(ex);
                }
            },

            verificaRealizaPergunta() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/VerificaRealizarPergunta`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaPergunta = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            imprimir() {
                let $this = this;
                $this.flImprimir = true;
                // Pass the element id here
                $this.$nextTick(function () {
                    $this.print();
                })
            },

            async print() {
                let $this = this;
                await $this.$htmlToPaper('printMe', {
                    styles: [
                        'assets/css/style.css',
                        //'assets/css/plugins/bootstrap.min.css',
                        //'assets/css/plugins/animation.css',
                        //'assets/css/plugins/feature.css',
                        //'assets/css/plugins/magnify.min.css',
                        //'assets/css/plugins/slick.css',
                        //'assets/css/plugins/slick-theme.css',
                        //'assets/css/plugins/lightbox.css',
                        //'assets/css/plugins/bootstrap-select.min.css',
                        //'assets/css/plugins/material-icons/css/materialicons.css',
                        //'assets/css/plugins/prism.css',
                    ],
                }, () => {
                    $this.flImprimir = false;
                    console.log('Printing completed or was cancelled!');
                });
            },

            word() {
                let $this = this;
                //$this.flImprimir = true;
                //$this.flWord = true;
                //// Pass the element id here
                //$this.$nextTick(function () {
                //    $this.gerarWord3();
                //})

                axios({
                    url: `${urlApi}/Conversa/DownloadWord/${$this.idConversa}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', 'documento.docx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            openDoutrina(tipo) {
                this.tipoDoutrina = tipo;
                this.showModalDoutrina = !this.showModalDoutrina;
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                        $this.loading.hide();
                    });
            },
        },
        mounted: function () {
            this.load();

            // signalR
            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            reload: function () {
                this.nova();
            },

            'formPergunta.idLegislacao': function () {
                this.formPergunta.tpPergunta = null;
                this.getTipoPergunta(this.formPergunta.idLegislacao);
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    textarea {
        border: 1px solid gray;
    }

    a:hover, li:hover {
        text-decoration: underline;
    }

    .referencias{
        padding-left: 30px;
    }

    .referencias li {
        font-size: 14px;
    }
    .resposta{
        text-align:justify;
    }

    .btn-selecionar {
        border-color: #ccc !important;
    }
</style>

